export const pulseRate30day = {
  total: 12,
  limit: 100,
  skip: 0,
  data: [
    {
      id: 29,
      value: '90',
      priority: 1,
      dateTime: '2021-10-19T13:08:23.000Z',
      createdAt: '2021-07-07T13:08:55.545Z',
      updatedAt: '2021-07-07T13:08:55.545Z',
      userId: 173,
      patientVitalId: 682,
      userDeviceId: null,
      unit: 'bpm',
      fromDevice: false,
      device: null,
    },
    {
      id: 13,
      value: '101',
      priority: 1,
      dateTime: '2021-10-27T21:28:04.000Z',
      createdAt: '2020-12-17T21:28:28.723Z',
      updatedAt: '2020-12-17T21:28:28.723Z',
      userId: 173,
      patientVitalId: 206,
      userDeviceId: null,
      unit: 'bpm',
      fromDevice: false,
      device: null,
    },
    {
      id: 26,
      value: '114',
      priority: 2,
      dateTime: '2021-10-24T18:20:00.000Z',
      createdAt: '2021-05-05T18:14:11.424Z',
      updatedAt: '2021-05-05T18:14:11.424Z',
      userId: 173,
      patientVitalId: 398,
      userDeviceId: null,
      unit: 'bpm',
      fromDevice: false,
      device: null,
    },
    {
      id: 22,
      value: '120',
      priority: 2,
      dateTime: '2021-10-21T18:20:00.000Z',
      createdAt: '2021-05-03T18:09:31.645Z',
      updatedAt: '2021-05-03T18:09:31.645Z',
      userId: 173,
      patientVitalId: 372,
      userDeviceId: null,
      unit: 'bpm',
      fromDevice: false,
      device: null,
    },
    {
      id: 21,
      value: '115',
      priority: 2,
      dateTime: '2021-10-26T18:45:00.000Z',
      createdAt: '2021-05-03T18:09:03.815Z',
      updatedAt: '2021-05-03T18:09:03.815Z',
      userId: 173,
      patientVitalId: 370,
      userDeviceId: null,
      unit: 'bpm',
      fromDevice: false,
      device: null,
    },
    {
      id: 20,
      value: '99',
      priority: 2,
      dateTime: '2021-10-18T18:20:00.000Z',
      createdAt: '2021-05-03T17:11:12.614Z',
      updatedAt: '2021-05-03T17:11:12.614Z',
      userId: 173,
      patientVitalId: 366,
      userDeviceId: null,
      unit: 'bpm',
      fromDevice: false,
      device: null,
    },
    {
      id: 18,
      value: '100',
      priority: 2,
      dateTime: '2021-10-17T18:20:00.000Z',
      createdAt: '2021-05-03T17:10:42.160Z',
      updatedAt: '2021-05-03T17:10:42.160Z',
      userId: 173,
      patientVitalId: 362,
      userDeviceId: null,
      unit: 'bpm',
      fromDevice: false,
      device: null,
    },
    {
      id: 25,
      value: '102',
      priority: 3,
      dateTime: '2021-10-28T18:20:00.000Z',
      createdAt: '2021-05-05T18:13:20.289Z',
      updatedAt: '2021-05-05T18:13:20.289Z',
      userId: 173,
      patientVitalId: 396,
      userDeviceId: null,
      unit: 'bpm',
      fromDevice: false,
      device: null,
    },
    {
      id: 27,
      value: '97',
      priority: 3,
      dateTime: '2021-10-27T18:20:00.000Z',
      createdAt: '2021-05-05T16:50:49.145Z',
      updatedAt: '2021-05-05T16:50:49.145Z',
      userId: 173,
      patientVitalId: 387,
      userDeviceId: null,
      unit: 'bpm',
      fromDevice: false,
      device: null,
    },
    {
      id: 17,
      value: '89',
      priority: 4,
      dateTime: '2021-10-27T18:20:00.000Z',
      createdAt: '2021-05-03T16:07:52.799Z',
      updatedAt: '2021-05-03T16:07:52.799Z',
      userId: 173,
      patientVitalId: 359,
      userDeviceId: null,
      unit: 'bpm',
      fromDevice: false,
      device: null,
    },
    {
      id: 16,
      value: '110',
      priority: 4,
      dateTime: '2021-10-25T18:20:00.000Z',
      createdAt: '2021-05-03T15:56:57.003Z',
      updatedAt: '2021-05-03T15:56:57.003Z',
      userId: 173,
      patientVitalId: 356,
      userDeviceId: null,
      unit: 'bpm',
      fromDevice: false,
      device: null,
    },
    {
      id: 15,
      value: '120',
      priority: 4,
      dateTime: '2021-10-11T18:20:00.000Z',
      createdAt: '2021-05-03T15:56:30.829Z',
      updatedAt: '2021-05-03T15:56:30.829Z',
      userId: 857,
      patientVitalId: 354,
      userDeviceId: null,
      unit: 'bpm',
      fromDevice: false,
      device: null,
    },
  ],
};

export const pulseRate7day = {
  total: 0,
  limit: 100,
  skip: 0,
  data: [],
};
